import http, {download, uploadCfg} from "../../../utils/HttpUtils";
import PurchasePoService from "../po/PurchasePoService";

//采购退货单接口服务
class PurchaseRoService {

    //新建采购退货单
    static async insert(data) {
        const apiUrl = "/purchase/ro/insert";
        return await http.post(apiUrl, data);
    }

    //修改采购退货单
    static async update(data) {
        const apiUrl = "/purchase/ro/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询采购退货单信息
    static async findByIdOrCode(id) {
        const apiUrl = `/purchase/ro/findByIdOrCode/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询采购退货单信息
    static async findPage(data) {
        const apiUrl = "/purchase/ro/findPage";
        return await http.post(apiUrl, data);
    }

    //作废采购单
    static async disable(id) {
        const apiUrl = `/purchase/ro/disable/${id}`;
        return await http.get(apiUrl);
    }

    //库房确认（出库）
    static async whConfirm(id) {
        const apiUrl = `/purchase/ro/whConfirm/${id}`;
        return await http.get(apiUrl);
    }

    //结算
    static async settle(data) {
        const apiUrl = `/purchase/ro/settle`;
        return await http.post(apiUrl, data);
    }

    //导出
    static async export(data) {
        const apiUrl = `/purchase/ro/export`;
        return await download(apiUrl, {type: "POST", data});
    }
    /******************************************************************************/
    //下载明细导入模板
    static async downloadDetailTpl(data) {
        const apiUrl = `/purchase/ro/detail/downloadTpl`;
        return await download(apiUrl, {data});
    }

    //导入明细
    static async detailImport() {
        const apiUrl = `/purchase/ro/detail/import`;
        return await http.post(apiUrl);
    }

    //加载采购明细
    static async purchaseDetailPage(data) {
        return await PurchasePoService.findDetailPage(data);
    }

    //获取导入配置
    static getImportDetailCfg(cfg) {
        const apiUrl = "/purchase/ro/detail/import";
        return uploadCfg(apiUrl, cfg);
    }
}

export default PurchaseRoService;
